import { render, staticRenderFns } from "./EditPONumberAction.vue?vue&type=template&id=2b41a068&"
import script from "./EditPONumberAction.vue?vue&type=script&lang=js&"
export * from "./EditPONumberAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports